(function () {
        'use strict';

        angular
            .module('jotApp')
            .controller('viewAllCommandsValueController', viewAllCommandsValueController);

        viewAllCommandsValueController.$inject = ['$timeout', '$scope', '$state', '$http','$sce', 'pagingParams', 'TabFleets', 'ListObjAndObjType', 'paginationConstants', 'ParseLinks',
            'AlertService', 'ListObjByObjTypeAndFleet', 'SetScheduleForAll', '$uibModal', 'ObjectStatusService', 'TabActions'];

        function viewAllCommandsValueController($timeout, $scope, $state, $http, $sce, pagingParams, TabFleets, ListObjAndObjType, paginationConstants, ParseLinks,
                                                AlertService, ListObjByObjTypeAndFleet, SetScheduleForAll, $uibModal, ObjectStatusService, TabActions) {
            var vm = this;
            vm.transition = transition;
            vm.changePageSize = changePageSize;
            vm.exportTable = exportTable;
            // vm.loadAllToExport = loadAllToExport;
            vm.tabFleets = [];
            vm.predicates = {};
            vm.selection = {};
            vm.selection.fleet = -1;
            vm.selection.objectType = -1;
            ObjectStatusService.init();
            vm.objParsed = 0;
            vm.tableIsLoading = false;

            vm.table = [];
            vm.tableToExport = [];

            vm.allDownloadReport = [];

            vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
            vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

            vm.showPdfFile = "";

            vm.message = {
                show: true,
                text: "Choose fleet and object type before selecting your report settings (PDF/XLSX) to download it or access history if available"
            }

            //caricamento delle flotte all'atterraggio in pagina
            TabFleets.query({}, onTabFleetsSuccess, onError);

            function onError(error) {
                AlertService.error(error.data.message);
                $timeout(function (){
                    vm.tableIsLoading =  false;
                },300)
            }

            function onTabFleetsSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabFleets.push(data[i]);
                }
                if (data.length === 1) {
                    vm.selectedFleet(data[0]);
                }
            }
            vm.resetFilter = function () {
                if (vm.tableIsLoading !== true) {
                    vm.fleet=null;
                    vm.charToSearch = '';
                    vm.onlyToUpdate = false;
                    vm.onlyOnline = false;
                }
            };
            /* selezionata la flotta popolo la select degli object type e la lista degli object in pagina
          annullando l'eventuale selezione di questi ultimi */
            vm.selectedFleet = function (fleet) {
                vm.allDownloadReport = [];
                vm.message.show = true;
                vm.message.text = "Choose object type before selecting your report settings (PDF/XLSX) to download it or access history if available";
                if (vm.tableIsLoading !== true) {
                    if (vm.selection.fleet != fleet.id) {
                        vm.selection.fleet = fleet.id;
                        vm.forms = [];
                        vm.table = [];
                        vm.tableToExport = [];
                        vm.currentPage = 1;
                    }
                    var query = {
                        id: fleet.id,
                        fleetId: fleet.id
                    };
                    ListObjAndObjType.query(query, onSuccess, onError);

                    function onSuccess(data) {
                        vm.tabObjectType = (data.tabObjectTypesList);
                        vm.fleet = fleet;
                        //reset delle due select dipendenti dalla flotta e forzatura della pagina 0 in tabella
                        vm.objType = null;
                        ObjectStatusService.sendChangePage(query);
                        transition(false);
                        if (data.tabObjectTypesList.length === 1) {
                            vm.objType = data.tabObjectTypesList[0]
                            vm.selectObjectType(vm.objType)
                        }
                        if (vm.tabObjectType.length === 0) {
                            vm.message.show = true;
                            vm.message.text = "Report not available: selected fleet has no associated object type";
                        }
                    }
                }
            };

            /* selezionato l'object type popolo la select e lista degli object in pagina
             annullando l'eventuale selezione di quest' ultimo */
            vm.selectObjectType = function (objType) {
                if (vm.tableIsLoading !== true) {
                    vm.tableIsLoading = true;
                    if (vm.selection.objectType != objType.id) {
                        vm.pagesChecked = [];
                        vm.checkNextPages = false;
                        vm.selection.objectType = objType.id;
                        vm.forms = [];
                        vm.table = [];
                        vm.tableToExport = [];
                        vm.currentPage = 1;
                    }
                    var query = {
                        typeName: objType.objectTypeName,
                        fleetName: vm.fleet.fleetName,
                        page: vm.currentPage -1,
                        size: vm.itemsPerPageChosen,
                        sort: null
                    }
                    // TabActions.allCommand(query, onSuccess, onError);

                    TabActions.allDownload(query, onSuccessDownload, onErrorDownload);

                    function onSuccessDownload(data, headers) {
                        vm.links = ParseLinks.parse(headers('link'));
                        vm.totalItems = headers('X-Total-Count');
                        vm.queryCount = vm.totalItems;
                        vm.page = vm.currentPage;
                        vm.allDownloadReport = data;
                        $timeout(function (){
                            vm.tableIsLoading = false;
                        },300);
                        if (vm.allDownloadReport.length === 0) {
                            vm.message.show = true;
                            vm.message.text = "History not available. Generate the first report for these objects to create it.";
                        } else {
                            vm.message.show = false;
                            vm.message.text = "";
                        }
                    }

                    function onErrorDownload() {}

                    // loadAllToExport();

                    function onSuccess(data, headers) {
                        vm.links = ParseLinks.parse(headers('link'));
                        vm.totalItems = headers('X-Total-Count');
                        vm.queryCount = vm.totalItems;
                        vm.page = vm.currentPage;
                        vm.table = [];
                        angular.forEach(data, function (d) {
                                vm.table.push({obj: d.object});
                                angular.forEach(d.commands, function (a) {
                                    vm.table.push({
                                        command: a.command,
                                        metricName: a.metric[0].metricName,
                                        metricValue: a.metric[0].metricValue
                                    });
                                    for (var i = 1; i < a.metric.length; i++) {
                                        vm.table.push({
                                            metricName: a.metric[i].metricName,
                                            metricValue: a.metric[i].metricValue
                                        });
                                    }

                                });
                            }
                        );
                        $timeout(function (){
                            vm.tableIsLoading =  false;
                        },300)
                        transition(false);
                    }
                }
            }

            function transition(recall, reset) {
                //eseguo la chiamata in base alle opzioni già selezionate
                if (recall) {
                    if (vm.objType) {
                        vm.selectObjectType(vm.objType, vm.currentPage, reset);
                    } else {
                        vm.selectedFleet(vm.fleet, vm.currentPage, reset);
                    }
                }
                $state.transitionTo($state.$current, {
                    page: vm.currentPage,
                    predicates: vm.predicates,
                    sort: null,
                    search: vm.charToSearch,
                    itemsPerPageChosen: vm.itemsPerPageChosen
                }, {notify: false, reload: false, location: "replace"});
            }

            function changePageSize() {
                if ((vm.queryCount / vm.itemsPerPageChosen) < vm.currentPage)
                    vm.currentPage = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
                vm.forms = [];
                vm.table = [];
                transition(true);
            }

            vm.openFilePdf = function (file) {
                var body = {
                    fileName: file.fileName,
                    fleetName: file.fleetName,
                    typeName: file.typeName
                }

                if (file.fileName.substr(file.fileName.length - 4) === '.pdf') {
                    $http.post('api/tab-actions/downloadReportFilePdf/', body, {responseType: 'blob'}
                    ).then(function (data) {
                        vm.showPdfFile = $sce.trustAsResourceUrl(
                            URL.createObjectURL(
                                new Blob([data.data], {type: data.headers("Content-Type")})));
                        $uibModal.open({
                            templateUrl: 'app/management/commands/showPdf.html',
                            controller: 'ShowPdfController',
                            controllerAs: 'vm',
                            size: 'md',
                            backdrop: 'static',
                            windowClass: 'app-modal-window',
                            resolve: {
                                content: function () {
                                    return vm.showPdfFile;
                                }
                            }
                        }).result.then(function () {
                            vm.showPdfFile = "";
                        });
                    });
                }
            }

            vm.downloadCommandsReport = function (file) {

                var body = {
                    fileName: file.fileName,
                    fleetName: file.fleetName,
                    typeName: file.typeName};

                if (file.fileName.substr(file.fileName.length - 4) === '.pdf') {
                    $http.post('api/tab-actions/downloadReportFilePdf/', body, { responseType: 'blob' }
                    ).then(function(data) {
                        downloadReportFile(data);
                    });
                } else {
                    $http.post('api/tab-actions/downloadReportFileXlsx/', body, { responseType: 'blob' }
                    ).then(function(data) {
                        downloadReportFile(data);
                    });
                }

                function downloadReportFile(data) {
                    var blob = new Blob([data.data], {type: data.headers("Content-Type")});
                    var url = window.URL.createObjectURL(blob);
                    var anchor = document.createElement("a");
                    var contentDisposition = data.headers("Content-Disposition");
                    anchor.download = contentDisposition.substring(contentDisposition.indexOf("=")+1);
                    anchor.href = url;
                    anchor.click();
                }

                function onErrorLink() {}
            }

            function exportTable(type) {

                $uibModal.open({
                    templateUrl: 'app/management/commands/selected-email.html',
                    controller: 'SelectedEmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    backdrop: 'static'
                }).result.then(function (result) {
                    downloadReport(type, result);
                });
            }

            function downloadReport(type, email) {
                var query = {
                    typeId: vm.objType.id,
                    fleetId: vm.fleet.id,
                    objTypeName: vm.objType.objectTypeName,
                    fleetName: vm.fleet.fleetName,
                    fileType: type,
                    principal: email.principal,
                    cc: email.cc,
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                }
                TabActions.download(query, onSuccessDownload, onErrorDownload);

                function onSuccessDownload() {
                    AlertService.success("JoT will send the report to your inbox. This process may take few hours.");
                }

                function onErrorDownload() {
                    AlertService.error("Generic Error");
                }
            }
        }
    }
)
();
